import React, { useState, useEffect } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Modal, Platform } from 'react-native';
import { colores } from '../../../../styles/variablesCss';

const Ordenamiento = ({ onSortChange }) => {
  const [showSortOptions, setShowSortOptions] = useState(false);
  const [sortOption, setSortOption] = useState(null);

  const sortOptions = [
    { id: 'relevancia', label: 'Relevancia' },
    { id: 'precio-asc', label: 'Precio: Menor a Mayor' },
    { id: 'precio-desc', label: 'Precio: Mayor a Menor' },
    { id: 'alfabetico', label: 'Alfabético: A-Z' },
    { id: 'alfabetico-desc', label: 'Alfabético: Z-A' },
    { id: 'mas-vendido', label: 'Más vendidos' },
    { id: 'ofertas', label: 'Ofertas primero' },
  ];

  const handleSortSelect = (option) => {
    setSortOption(option);
    setShowSortOptions(false);
    onSortChange(option);
  };

  // Obtener el texto que se muestra en el botón según la opción seleccionada
  const getSortButtonText = () => {
    if (!sortOption) return 'Relevancia';
    const selectedOption = sortOptions.find(option => option.id === sortOption);
    return selectedOption ? selectedOption.label : 'Relevancia';
  };

  // Guardar la posición del botón para colocar el modal correctamente
  const [buttonLayout, setButtonLayout] = useState({ x: 0, y: 0, width: 0, height: 0 });
  
  const measureButton = () => {
    if (showSortOptions) return;
    
    // Esperar a que el componente se renderice
    setTimeout(() => {
      sortButtonRef.current?.measure((fx, fy, width, height, px, py) => {
        setButtonLayout({
          x: px,
          y: py,
          width: width,
          height: height
        });
      });
    }, 100);
  };

  // Referencia al botón de ordenamiento
  const sortButtonRef = React.useRef();

  const Chevron = ({ open }) => {
    const rotate = open ? '135deg' : '-45deg';
    return (
      <View style={styles.chevronWrapper}>
        <View style={[styles.chevron, { transform: [{ rotate }] }]} />
      </View>
    );
  };

  return (
    <View style={styles.sortContainer}>
      <Text style={styles.sortLabel}>Ordenar por: </Text>
      <TouchableOpacity 
        ref={sortButtonRef}
        style={styles.sortButton}
        onPress={() => {
          measureButton();
          setShowSortOptions(!showSortOptions);
        }}
      >
        <Text style={styles.sortButtonText}>{getSortButtonText()}</Text>
        <Chevron open={showSortOptions} />
      </TouchableOpacity>
      
      <Modal
        visible={showSortOptions}
        transparent={true}
        animationType="fade"
        onRequestClose={() => setShowSortOptions(false)}
      >
        <TouchableOpacity 
          style={styles.modalOverlay}
          activeOpacity={1}
          onPress={() => setShowSortOptions(false)}
        >
          <View style={[styles.modalContainer, {
            position: 'absolute',
            left: buttonLayout.x,
            top: buttonLayout.y + buttonLayout.height + 2,
          }]}>
            <View style={styles.sortOptionsDropdown}>
              {sortOptions.map((option) => (
                <TouchableOpacity
                  key={option.id}
                  style={[
                    styles.sortOptionItem,
                    sortOption === option.id && styles.selectedSortOption
                  ]}
                  onPress={() => handleSortSelect(option.id)}
                >
                  <Text style={[
                    styles.sortOptionText,
                    sortOption === option.id && styles.selectedSortOptionText
                  ]}>
                    {option.label}
                  </Text>
                </TouchableOpacity>
              ))}
            </View>
          </View>
        </TouchableOpacity>
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  sortContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
    zIndex: 9999,
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.1)',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    width: '100%',
    height: '100%',
  },
  modalContainer: {
    width: 250,
    backgroundColor: 'transparent',
  },
  sortLabel: {
    marginRight: 5,
    fontSize: 14,
  },
  sortButton: {
    flexDirection: 'row',
    alignItems: 'center', 
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 5,
    minWidth: 140,
  },
  sortButtonText: {
    fontSize: 14,
    marginRight: 5,
    color: colores.rojo,
  },
  chevronWrapper: {
    width: 16,
    height: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  chevron: {
    width: 9,
    height: 9,
    borderLeftWidth: 2,
    borderBottomWidth: 2,
    borderColor: colores.rojo,
  },
  sortOptionsDropdown: {
    width: 180,
    backgroundColor: colores.blanco,
    borderRadius: 5,
    marginTop: 0,
    borderWidth: 1,
    borderColor: '#e0e0e0',
    ...(Platform.OS === 'web'
      ? { boxShadow: '0 4px 12px rgba(0,0,0,0.25)' }
      : {
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 4 },
          shadowOpacity: 0.25,
          shadowRadius: 5,
          elevation: 8,
        }
    ),
  },
  sortOptionItem: {
    padding: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
  },
  sortOptionText: {
    fontSize: 14,
  },
  selectedSortOption: {
    backgroundColor: '#f8f8f8',
  },
  selectedSortOptionText: {
    fontWeight: 'bold',
    color: colores.rojo,
  },
});

export default Ordenamiento;
